import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { Spinner } from "reactstrap";
export function ConfirmCancel(props) {
  const { promptText, modal, progress } = props;
  const JSX = (
    <Modal
      isOpen={modal}
      centered={true}
      fade={false}
      className={"modal-dialog modal-dialog-centered modal-md"}
    >
      <ModalBody className="text-center">
        <p class="text-center m-0 font-weight-regular">{promptText}</p>
      </ModalBody>
      <ModalFooter>
        {progress === true && (
          <button
            type="button"
            class="btn btn-sm btn-primary"
            onClick={props.onYes}
          >
            <Spinner size="sm" /> Saving
          </button>
        )}
        {progress !== true && (
          <button
            type="button"
            class="btn btn-sm btn-primary"
            onClick={props.onYes}
          >
            Yes
          </button>
        )}

        <button
          type="button"
          class="btn btn-sm btn-dark"
          onClick={props.onNo}
          disabled={progress === true ? true : false}
        >
          No
        </button>
        <div class="mt-3"></div>
      </ModalFooter>
    </Modal>
  );
  return JSX;
}
